import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import AddSecondaryEmailForm from 'src/components/AddSecondaryEmailPopup/AddSecondaryEmailForm'
import VerifySecondaryEmailForm from 'src/components/AddSecondaryEmailPopup/VerifySecondaryEmailForm'
import Popup from 'src/components/Popup/Popup'
import { ImageNames } from 'src/enums'
import { useFlyoutDispatch } from 'src/hooks'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import { useTranslate } from 'src/localization/Trns'
import { createSetIsAddSecondaryEmailPopupOpen } from 'src/redux/actions/app.actions'
import { getSecondaryEmails } from 'src/redux/actions/data/users.actions'
import { selectSelectedSecondaryEmailFromState } from 'src/redux/selectors/data/secondaryEmails.selectors'
import { css } from 'styled-components'

export type SecondaryEmailFlatFields = {
  email?: string
}

export type SecondaryEmailVerificationFlatFields = {
  verificationCode?: string
}

const AddSecondaryEmailPopup: React.FC = () => {
  const translate = useTranslate()

  const selectedSecondaryEmail = useSelector(
    selectSelectedSecondaryEmailFromState,
  )
  const buildingsImageSrc = useColorOrGrayscaleImage(ImageNames.Buildings)

  const dispatch = useFlyoutDispatch()

  return (
    <Popup
      noPadding
      onClose={(): void => {
        dispatch(createSetIsAddSecondaryEmailPopupOpen(false))
        dispatch(getSecondaryEmails())
      }}
    >
      <div
        css={css`
          position: relative;
          padding: 60px;
        `}
      >
        <img
          src={buildingsImageSrc}
          alt=""
          css={css`
            position: absolute;
            top: 0;
            right: 0;
            border-top-right-radius: 10px;
            ${getBreakpointDown(breakpointSizes.XSM)(css`
              display: none;
            `)}
          `}
        />
        <div
          css={css`
            display: flex;
            flex-direction: column;
            ${getFontCss(
              32,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
            margin-bottom: 20px;
          `}
        >
          {translate('Add a secondary email')}
        </div>
        <div
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <div
            css={css`
              margin-bottom: 20px;
            `}
          >
            {translate(
              'Your secondary email address can be used as an additional way to forward receipts. You may not use it on login.',
            )}
          </div>
          {translate(
            "After entering your email, you'll need to confirm the 6-digit verification code we send you. If you don't see it, please check your spam folder.",
          )}
        </div>
        <div
          css={css`
            margin-top: 40px;
            display: flex;
            flex-direction: column;
          `}
        >
          {selectedSecondaryEmail ? (
            <VerifySecondaryEmailForm secondaryEmail={selectedSecondaryEmail} />
          ) : (
            <AddSecondaryEmailForm />
          )}
        </div>
      </div>
    </Popup>
  )
}

export default AddSecondaryEmailPopup
